import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";

export function DialogTear({
    isVisible, setIsVisible,
    formData, setFormData,
    config, toast,
    handleUpdate,
}) {
    return (
        <Dialog
            header="Dados do Tear"
            onHide={() => setIsVisible(!isVisible)}
            style={{ minWidth: "20vw" }}
            visible={isVisible}
        >
            <div className="p-fluid">
                <div className="p-field">
                    <label htmlFor="tear">Tear: *</label>
                    <InputText
                        id="tear"
                        className="p-m-1"
                        min={1}
                        type="number"
                        value={formData.tear}
                        onChange={e => {
                            if (parseInt(e.target.value) <= config.teares || e.target.value === '') {
                                setFormData({ ...formData, tear: e.target.value });
                            } else {
                                toast.current.show({ summary: 'Aviso', severity: 'warn', detail: 'Informe valores de até no máximo ' + config.teares });
                            }
                        }}
                        placeholder="Exemplo: 60"
                    />
                </div>
                <div className="p-field">
                    <label htmlFor="grupo">Grupo: *</label>
                    <InputText
                        id="grupo"
                        className="p-m-1"
                        min={1}
                        type="number"
                        value={formData.grupo}
                        onChange={e => {
                            if (parseInt(e.target.value) <= config.grupos || e.target.value === '') {
                                setFormData({ ...formData, grupo: e.target.value });
                            } else {
                                toast.current.show({ summary: 'Aviso', severity: 'warn', detail: 'Informe valores de até no máximo ' + config.grupos });
                            }
                        }}
                        placeholder="Exemplo: 3"
                    />
                </div>
                <div className="p-field">
                    <label htmlFor="modelo">Modelo: </label>
                    <InputText
                        id="modelo"
                        className="p-m-1"
                        value={formData.modelo}
                        onChange={e => setFormData({ ...formData, modelo: e.target.value })}
                    />
                </div>
                <div className="p-field">
                    <label htmlFor="serial">Serial: </label>
                    <InputText
                        id="serial"
                        className="p-m-1"
                        value={formData.serial}
                        onChange={e => setFormData({ ...formData, serial: e.target.value })}
                    />
                </div>
                <div className="p-grid">
                    <div className="p-field p-col">
                        <label htmlFor="data_aquisicao">Data Aquisição: </label>
                        <Calendar
                            id="data_aquisicao"
                            className="p-m-1"
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            value={formData.data_aquisicao}
                            onChange={e => setFormData({ ...formData, data_aquisicao: e.value })}
                        />
                    </div>
                    <div className="p-field p-col">
                        <label htmlFor="passadas_tear">Passadas: </label>
                        <InputText
                            id="passadas_tear"
                            className="p-m-1"
                            type="number"
                            step={0}
                            value={formData.passadas_tear || ""}
                            onChange={e => {
                                if (parseInt(e.target.value) || e.target.value === "") {
                                    setFormData({ ...formData, passadas_tear: e.target.value });
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="p-grid">
                    <div className="p-field p-col">
                        <label htmlFor="pos_x">Posição X: </label>
                        <InputText
                            id="pos_x"
                            className="p-m-1"
                            type="number"
                            value={formData.pos_x}
                            onChange={e => {
                                if ((e.target.value >= 1 && e.target.value <= 16) || e.target.value === "") {
                                    setFormData({ ...formData, pos_x: e.target.value });
                                }
                            }}
                        />
                    </div>
                    <div className="p-field p-col">
                        <label htmlFor="pos_y">Posição Y: </label>
                        <InputText
                            id="pos_y"
                            className="p-m-1"
                            type="number"
                            value={formData.pos_y}
                            onChange={e => {
                                if ((e.target.value >= 1 && e.target.value <= 8) || e.target.value === "") {
                                    setFormData({ ...formData, pos_y: e.target.value });
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="p-field">
                    <Button
                        className="p-m-1"
                        label="Salvar"
                        type="button"
                        title="Clique para salvar os dados"
                        onClick={() => handleUpdate(formData.tear, formData.grupo)}
                    />
                </div>
            </div>
        </Dialog>
    );
}